import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentBeforeAddDataEvent} from '../hooks'
import _ from 'lodash'

export const setZeroLeft = (createExtArgs: CreateExtArgs, data: ComponentBeforeAddDataEvent) => {
    const {componentDefinition} = data
    _.set(componentDefinition, ['layout', 'x'], 0)
}
